import { IConfigCache, IConfigCacheName } from '../interface/config';

const settings: IConfigCache = {
    [IConfigCacheName.PublicAssets]: {
        cacheName: 'app-public-cache',
        expiration: 21 * 24 * 60 * 60,
        maxEntries: 200,
        matcher: /public\/*/,
    },
    [IConfigCacheName.BuildAssets]: {
        cacheName: 'app-build-cache',
        expiration: 21 * 24 * 60 * 60,
        maxEntries: 200,
        matcher: /static\/*/,
    },
    [IConfigCacheName.WorkspaceMedia]: {
        cacheName: 'app-media-cache',
        expiration: 21 * 24 * 60 * 60,
        maxEntries: 1000,
        /* match all minus media.json */
        matcher: /app.GetFile/,
        fetchOptions: {
            /* When the browser loads the associated asset,
               we need to intercept in the service-worker & resolve. 
               By default all requests from the browser have no cors.
               Changes below allow non-opaque responses to be saved to cache */
            mode: 'cors',
        },
    },
    [IConfigCacheName.WorkspaceStream]: {
        cacheName: 'app-stream-cache',
        expiration: 21 * 24 * 60 * 60,
        maxEntries: 1000,
        /* match all minus media.json */
        matcher: new RegExp('atsweb.app/media/[0-9]*/(?!media.json.*)', 'g'),
        fetchOptions: {
            /* When the browser loads the associated asset,
               we need to intercept in the service-worker & resolve. 
               By default all requests from the browser have no cors.
               Changes below allow non-opaque responses to be saved to cache */
            mode: 'cors',
            headers: { 'X-Force-Cors': 'true' },
            credentials: 'omit',
        },
        ignoreSearch: true,
    },
    [IConfigCacheName.AppToken]: {
        tokenPath: '/apptoken',
    },
};

export default settings;
